import React from 'react';
import {
  Action,
  Actions,
  FileDownloadIcon,
  ActionBar,
} from '@gogame/components';
import { FullScreenToggler } from '@gogame/data-grid';
import { SearchField, useScreenState, useScreenTitle } from '@gogame/screens';

import { useIsAllowed } from '@gogame/permissions';
import { MANAGE_GAME_EVENTS } from 'scenes/Events/constants';
import { useExportEvents } from 'scenes/Events/data';

export default ({ onCreate }) => {
  const [screenTitle] = useScreenTitle();
  const exportEvents = useExportEvents();
  const canManageGameEvents = useIsAllowed()(MANAGE_GAME_EVENTS);
  const screenState = useScreenState();
  const handleExport = async () => {
    await exportEvents({
      filters: screenState.filters,
      tableSettings: screenState.tableSettings,
      searchQuery: screenState.searchQuery,
    });
  };

  return (
    <>
      <ActionBar
        title={screenTitle}
        search={<SearchField tooltip={'Search by name, GG Event Name'} />}
        secondaryActions={
          <Actions>
            <Action
              data-cy={'downloadFile'}
              icon={<FileDownloadIcon />}
              onClick={handleExport}
              label={'Export'}
            />
            <Action component={FullScreenToggler} />
          </Actions>
        }
        primaryActions={
          canManageGameEvents ? (
            <Actions>
              <Action
                border={true}
                button={true}
                add={true}
                iconContent={true}
                tooltip={'Add Game Event'}
                variant={'outlined'}
                onClick={onCreate}
              />
            </Actions>
          ) : null
        }
      />
    </>
  );
};
